"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: quota/item.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fquota%2Fitem.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemToJSON = exports.itemFromJSON = exports.Item = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.quota.proto';
/**
 * Items that have configured quota limits
 */
var Item;
(function (Item) {
    Item["INVALID_ITEM"] = "INVALID_ITEM";
    Item["FAMILY_INVITE"] = "FAMILY_INVITE";
    Item["ACTIVE_EXTERNAL_CARD"] = "ACTIVE_EXTERNAL_CARD";
    Item["DEVICE_ONBOARDED_USER"] = "DEVICE_ONBOARDED_USER";
    Item["FAMILY_MEMBER"] = "FAMILY_MEMBER";
    Item["KYC_ATTEMPT"] = "KYC_ATTEMPT";
    /**
     * PHYSICAL_CARD_REPLACEMENT - Physical Credit Card Replacement
     */
    Item["PHYSICAL_CARD_REPLACEMENT"] = "PHYSICAL_CARD_REPLACEMENT";
    /**
     * VIRTUAL_CARD_REPLACEMENT - Virtual Credit Card Replacement
     */
    Item["VIRTUAL_CARD_REPLACEMENT"] = "VIRTUAL_CARD_REPLACEMENT";
    Item["REFERRAL_REDEMPTION"] = "REFERRAL_REDEMPTION";
    Item["REFERRAL_REDEMPTION_PER_DEVICE"] = "REFERRAL_REDEMPTION_PER_DEVICE";
    Item["EXTERNAL_CARD_USER"] = "EXTERNAL_CARD_USER";
    Item["FREE_CASH_DEPOSIT"] = "FREE_CASH_DEPOSIT";
    Item["FREE_OUT_OF_NETWORK_ATM_WITHDRAWAL"] = "FREE_OUT_OF_NETWORK_ATM_WITHDRAWAL";
    Item["EXTERNAL_BANK_USER"] = "EXTERNAL_BANK_USER";
    Item["FAMILY_COSPONSOR"] = "FAMILY_COSPONSOR";
    Item["FUNDING"] = "FUNDING";
    Item["REWARD_PAYOUT_CENTS"] = "REWARD_PAYOUT_CENTS";
    Item["REWARD_PAYOUT_COUNT"] = "REWARD_PAYOUT_COUNT";
    Item["FULL_SSN_KYC_ATTEMPT"] = "FULL_SSN_KYC_ATTEMPT";
    /**
     * FREE_PHYSICAL_CARD_REPLACEMENT - Free Plastic Credit Card Replacement
     */
    Item["FREE_PHYSICAL_CARD_REPLACEMENT"] = "FREE_PHYSICAL_CARD_REPLACEMENT";
    /**
     * FREE_METAL_CARD_REPLACEMENT - Free Metal Credit Card Replacement
     */
    Item["FREE_METAL_CARD_REPLACEMENT"] = "FREE_METAL_CARD_REPLACEMENT";
    Item["OVERDRAFT_PROTECTION_REACTIVATION"] = "OVERDRAFT_PROTECTION_REACTIVATION";
    Item["BNPL_REACTIVATION"] = "BNPL_REACTIVATION";
    Item["LENDING_REACTIVATION"] = "LENDING_REACTIVATION";
    Item["BATCH_FUNDING"] = "BATCH_FUNDING";
    Item["PLUS_TIER_INSTANT_ACTIVATION"] = "PLUS_TIER_INSTANT_ACTIVATION";
    Item["SIGNUP_REWARDS_PER_DEVICE"] = "SIGNUP_REWARDS_PER_DEVICE";
    Item["DOB_UPDATE"] = "DOB_UPDATE";
    Item["OPEN_SAVINGS_GOAL"] = "OPEN_SAVINGS_GOAL";
    Item["OPEN_INSTALLMENT_LOAN"] = "OPEN_INSTALLMENT_LOAN";
    Item["REWARD_PAYOUT_TOTAL_MONTHLY"] = "REWARD_PAYOUT_TOTAL_MONTHLY";
    Item["REWARD_PAYOUT_TOTAL_ANNUAL"] = "REWARD_PAYOUT_TOTAL_ANNUAL";
    Item["REFERRAL_CONVERSION"] = "REFERRAL_CONVERSION";
    Item["FROZEN_APPLICATION_RETRIES"] = "FROZEN_APPLICATION_RETRIES";
    Item["FREE_STEP_BLACK_TRIAL"] = "FREE_STEP_BLACK_TRIAL";
    Item["DEVICE_USER"] = "DEVICE_USER";
    Item["EXTERNAL_CARD_FAMILY"] = "EXTERNAL_CARD_FAMILY";
    Item["EXTERNAL_BANK_FAMILY"] = "EXTERNAL_BANK_FAMILY";
    Item["SSN"] = "SSN";
    Item["FAMILY_CHANGE"] = "FAMILY_CHANGE";
    Item["FREE_METAL_CARD_REPLACEMENT_V2"] = "FREE_METAL_CARD_REPLACEMENT_V2";
    Item["SPIN_THE_WHEEL_ATTEMPT"] = "SPIN_THE_WHEEL_ATTEMPT";
    Item["ADMIN_JUSTIFIED_IMPERSONATIONS_DAILY"] = "ADMIN_JUSTIFIED_IMPERSONATIONS_DAILY";
    Item["ADMIN_UNJUSTIFIED_IMPERSONATIONS_DAILY"] = "ADMIN_UNJUSTIFIED_IMPERSONATIONS_DAILY";
    /**
     * VIRTUAL_DEBIT_CARD_REPLACEMENT - Virtual Debit Card Replacement
     */
    Item["VIRTUAL_DEBIT_CARD_REPLACEMENT"] = "VIRTUAL_DEBIT_CARD_REPLACEMENT";
    /**
     * FREE_STEP_MOBILE_TRIAL - Free month of Step Mobile
     */
    Item["FREE_STEP_MOBILE_TRIAL"] = "FREE_STEP_MOBILE_TRIAL";
    Item["_TEST_ITEM_ONE"] = "_TEST_ITEM_ONE";
    Item["_TEST_ITEM_TWO"] = "_TEST_ITEM_TWO";
    Item["_TEST_ITEM_FAMILY"] = "_TEST_ITEM_FAMILY";
    Item["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Item || (exports.Item = Item = {}));
function itemFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ITEM':
            return Item.INVALID_ITEM;
        case 1:
        case 'FAMILY_INVITE':
            return Item.FAMILY_INVITE;
        case 2:
        case 'ACTIVE_EXTERNAL_CARD':
            return Item.ACTIVE_EXTERNAL_CARD;
        case 3:
        case 'DEVICE_ONBOARDED_USER':
            return Item.DEVICE_ONBOARDED_USER;
        case 4:
        case 'FAMILY_MEMBER':
            return Item.FAMILY_MEMBER;
        case 5:
        case 'KYC_ATTEMPT':
            return Item.KYC_ATTEMPT;
        case 6:
        case 'PHYSICAL_CARD_REPLACEMENT':
            return Item.PHYSICAL_CARD_REPLACEMENT;
        case 7:
        case 'VIRTUAL_CARD_REPLACEMENT':
            return Item.VIRTUAL_CARD_REPLACEMENT;
        case 8:
        case 'REFERRAL_REDEMPTION':
            return Item.REFERRAL_REDEMPTION;
        case 9:
        case 'REFERRAL_REDEMPTION_PER_DEVICE':
            return Item.REFERRAL_REDEMPTION_PER_DEVICE;
        case 10:
        case 'EXTERNAL_CARD_USER':
            return Item.EXTERNAL_CARD_USER;
        case 11:
        case 'FREE_CASH_DEPOSIT':
            return Item.FREE_CASH_DEPOSIT;
        case 12:
        case 'FREE_OUT_OF_NETWORK_ATM_WITHDRAWAL':
            return Item.FREE_OUT_OF_NETWORK_ATM_WITHDRAWAL;
        case 13:
        case 'EXTERNAL_BANK_USER':
            return Item.EXTERNAL_BANK_USER;
        case 14:
        case 'FAMILY_COSPONSOR':
            return Item.FAMILY_COSPONSOR;
        case 15:
        case 'FUNDING':
            return Item.FUNDING;
        case 16:
        case 'REWARD_PAYOUT_CENTS':
            return Item.REWARD_PAYOUT_CENTS;
        case 17:
        case 'REWARD_PAYOUT_COUNT':
            return Item.REWARD_PAYOUT_COUNT;
        case 18:
        case 'FULL_SSN_KYC_ATTEMPT':
            return Item.FULL_SSN_KYC_ATTEMPT;
        case 19:
        case 'FREE_PHYSICAL_CARD_REPLACEMENT':
            return Item.FREE_PHYSICAL_CARD_REPLACEMENT;
        case 27:
        case 'FREE_METAL_CARD_REPLACEMENT':
            return Item.FREE_METAL_CARD_REPLACEMENT;
        case 20:
        case 'OVERDRAFT_PROTECTION_REACTIVATION':
            return Item.OVERDRAFT_PROTECTION_REACTIVATION;
        case 21:
        case 'BNPL_REACTIVATION':
            return Item.BNPL_REACTIVATION;
        case 22:
        case 'LENDING_REACTIVATION':
            return Item.LENDING_REACTIVATION;
        case 23:
        case 'BATCH_FUNDING':
            return Item.BATCH_FUNDING;
        case 24:
        case 'PLUS_TIER_INSTANT_ACTIVATION':
            return Item.PLUS_TIER_INSTANT_ACTIVATION;
        case 25:
        case 'SIGNUP_REWARDS_PER_DEVICE':
            return Item.SIGNUP_REWARDS_PER_DEVICE;
        case 26:
        case 'DOB_UPDATE':
            return Item.DOB_UPDATE;
        case 28:
        case 'OPEN_SAVINGS_GOAL':
            return Item.OPEN_SAVINGS_GOAL;
        case 29:
        case 'OPEN_INSTALLMENT_LOAN':
            return Item.OPEN_INSTALLMENT_LOAN;
        case 30:
        case 'REWARD_PAYOUT_TOTAL_MONTHLY':
            return Item.REWARD_PAYOUT_TOTAL_MONTHLY;
        case 31:
        case 'REWARD_PAYOUT_TOTAL_ANNUAL':
            return Item.REWARD_PAYOUT_TOTAL_ANNUAL;
        case 33:
        case 'REFERRAL_CONVERSION':
            return Item.REFERRAL_CONVERSION;
        case 34:
        case 'FROZEN_APPLICATION_RETRIES':
            return Item.FROZEN_APPLICATION_RETRIES;
        case 35:
        case 'FREE_STEP_BLACK_TRIAL':
            return Item.FREE_STEP_BLACK_TRIAL;
        case 38:
        case 'DEVICE_USER':
            return Item.DEVICE_USER;
        case 36:
        case 'EXTERNAL_CARD_FAMILY':
            return Item.EXTERNAL_CARD_FAMILY;
        case 37:
        case 'EXTERNAL_BANK_FAMILY':
            return Item.EXTERNAL_BANK_FAMILY;
        case 39:
        case 'SSN':
            return Item.SSN;
        case 40:
        case 'FAMILY_CHANGE':
            return Item.FAMILY_CHANGE;
        case 41:
        case 'FREE_METAL_CARD_REPLACEMENT_V2':
            return Item.FREE_METAL_CARD_REPLACEMENT_V2;
        case 42:
        case 'SPIN_THE_WHEEL_ATTEMPT':
            return Item.SPIN_THE_WHEEL_ATTEMPT;
        case 43:
        case 'ADMIN_JUSTIFIED_IMPERSONATIONS_DAILY':
            return Item.ADMIN_JUSTIFIED_IMPERSONATIONS_DAILY;
        case 44:
        case 'ADMIN_UNJUSTIFIED_IMPERSONATIONS_DAILY':
            return Item.ADMIN_UNJUSTIFIED_IMPERSONATIONS_DAILY;
        case 45:
        case 'VIRTUAL_DEBIT_CARD_REPLACEMENT':
            return Item.VIRTUAL_DEBIT_CARD_REPLACEMENT;
        case 46:
        case 'FREE_STEP_MOBILE_TRIAL':
            return Item.FREE_STEP_MOBILE_TRIAL;
        case 10001:
        case '_TEST_ITEM_ONE':
            return Item._TEST_ITEM_ONE;
        case 10002:
        case '_TEST_ITEM_TWO':
            return Item._TEST_ITEM_TWO;
        case 10003:
        case '_TEST_ITEM_FAMILY':
            return Item._TEST_ITEM_FAMILY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Item.UNRECOGNIZED;
    }
}
exports.itemFromJSON = itemFromJSON;
function itemToJSON(object) {
    switch (object) {
        case Item.INVALID_ITEM:
            return 'INVALID_ITEM';
        case Item.FAMILY_INVITE:
            return 'FAMILY_INVITE';
        case Item.ACTIVE_EXTERNAL_CARD:
            return 'ACTIVE_EXTERNAL_CARD';
        case Item.DEVICE_ONBOARDED_USER:
            return 'DEVICE_ONBOARDED_USER';
        case Item.FAMILY_MEMBER:
            return 'FAMILY_MEMBER';
        case Item.KYC_ATTEMPT:
            return 'KYC_ATTEMPT';
        case Item.PHYSICAL_CARD_REPLACEMENT:
            return 'PHYSICAL_CARD_REPLACEMENT';
        case Item.VIRTUAL_CARD_REPLACEMENT:
            return 'VIRTUAL_CARD_REPLACEMENT';
        case Item.REFERRAL_REDEMPTION:
            return 'REFERRAL_REDEMPTION';
        case Item.REFERRAL_REDEMPTION_PER_DEVICE:
            return 'REFERRAL_REDEMPTION_PER_DEVICE';
        case Item.EXTERNAL_CARD_USER:
            return 'EXTERNAL_CARD_USER';
        case Item.FREE_CASH_DEPOSIT:
            return 'FREE_CASH_DEPOSIT';
        case Item.FREE_OUT_OF_NETWORK_ATM_WITHDRAWAL:
            return 'FREE_OUT_OF_NETWORK_ATM_WITHDRAWAL';
        case Item.EXTERNAL_BANK_USER:
            return 'EXTERNAL_BANK_USER';
        case Item.FAMILY_COSPONSOR:
            return 'FAMILY_COSPONSOR';
        case Item.FUNDING:
            return 'FUNDING';
        case Item.REWARD_PAYOUT_CENTS:
            return 'REWARD_PAYOUT_CENTS';
        case Item.REWARD_PAYOUT_COUNT:
            return 'REWARD_PAYOUT_COUNT';
        case Item.FULL_SSN_KYC_ATTEMPT:
            return 'FULL_SSN_KYC_ATTEMPT';
        case Item.FREE_PHYSICAL_CARD_REPLACEMENT:
            return 'FREE_PHYSICAL_CARD_REPLACEMENT';
        case Item.FREE_METAL_CARD_REPLACEMENT:
            return 'FREE_METAL_CARD_REPLACEMENT';
        case Item.OVERDRAFT_PROTECTION_REACTIVATION:
            return 'OVERDRAFT_PROTECTION_REACTIVATION';
        case Item.BNPL_REACTIVATION:
            return 'BNPL_REACTIVATION';
        case Item.LENDING_REACTIVATION:
            return 'LENDING_REACTIVATION';
        case Item.BATCH_FUNDING:
            return 'BATCH_FUNDING';
        case Item.PLUS_TIER_INSTANT_ACTIVATION:
            return 'PLUS_TIER_INSTANT_ACTIVATION';
        case Item.SIGNUP_REWARDS_PER_DEVICE:
            return 'SIGNUP_REWARDS_PER_DEVICE';
        case Item.DOB_UPDATE:
            return 'DOB_UPDATE';
        case Item.OPEN_SAVINGS_GOAL:
            return 'OPEN_SAVINGS_GOAL';
        case Item.OPEN_INSTALLMENT_LOAN:
            return 'OPEN_INSTALLMENT_LOAN';
        case Item.REWARD_PAYOUT_TOTAL_MONTHLY:
            return 'REWARD_PAYOUT_TOTAL_MONTHLY';
        case Item.REWARD_PAYOUT_TOTAL_ANNUAL:
            return 'REWARD_PAYOUT_TOTAL_ANNUAL';
        case Item.REFERRAL_CONVERSION:
            return 'REFERRAL_CONVERSION';
        case Item.FROZEN_APPLICATION_RETRIES:
            return 'FROZEN_APPLICATION_RETRIES';
        case Item.FREE_STEP_BLACK_TRIAL:
            return 'FREE_STEP_BLACK_TRIAL';
        case Item.DEVICE_USER:
            return 'DEVICE_USER';
        case Item.EXTERNAL_CARD_FAMILY:
            return 'EXTERNAL_CARD_FAMILY';
        case Item.EXTERNAL_BANK_FAMILY:
            return 'EXTERNAL_BANK_FAMILY';
        case Item.SSN:
            return 'SSN';
        case Item.FAMILY_CHANGE:
            return 'FAMILY_CHANGE';
        case Item.FREE_METAL_CARD_REPLACEMENT_V2:
            return 'FREE_METAL_CARD_REPLACEMENT_V2';
        case Item.SPIN_THE_WHEEL_ATTEMPT:
            return 'SPIN_THE_WHEEL_ATTEMPT';
        case Item.ADMIN_JUSTIFIED_IMPERSONATIONS_DAILY:
            return 'ADMIN_JUSTIFIED_IMPERSONATIONS_DAILY';
        case Item.ADMIN_UNJUSTIFIED_IMPERSONATIONS_DAILY:
            return 'ADMIN_UNJUSTIFIED_IMPERSONATIONS_DAILY';
        case Item.VIRTUAL_DEBIT_CARD_REPLACEMENT:
            return 'VIRTUAL_DEBIT_CARD_REPLACEMENT';
        case Item.FREE_STEP_MOBILE_TRIAL:
            return 'FREE_STEP_MOBILE_TRIAL';
        case Item._TEST_ITEM_ONE:
            return '_TEST_ITEM_ONE';
        case Item._TEST_ITEM_TWO:
            return '_TEST_ITEM_TWO';
        case Item._TEST_ITEM_FAMILY:
            return '_TEST_ITEM_FAMILY';
        case Item.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.itemToJSON = itemToJSON;
//# sourceMappingURL=item.js.map